import AccountDispatcher from '@reducers/account/dispatcher';
import { useAppDispatch, useAppSelector } from '@reducers/index';
import { useEffect, useMemo } from 'react';
import { getIsOutOfCreditsByCreditType } from '../components/AppPopups/FreeTrialDecisionPopup/utils';
const useFetchAccountCredits = () => {
    const dispatch = useAppDispatch();
    const { accountCreditsTypes } = useAppSelector(state => ({ accountCreditsTypes: state.account.accountCreditsTypes }));
    useEffect(() => {
        dispatch(AccountDispatcher.fetchAccountCredits());
    }, []);
    const outOfCreditsBalance = useMemo(() => getIsOutOfCreditsByCreditType(accountCreditsTypes), [accountCreditsTypes]);
    return { accountCreditsTypes, outOfCreditsBalance };
};
export default useFetchAccountCredits;
